var React = require('react');

// Styles
require('./Login.scss');

// Assets
var chevronIcon = require('images/chevron.svg');

if (typeof window !== "undefined") {
	window.loginStatusReady = window.loginStatusReady || false;
	window.loginStatus = window.loginStatus || null;
}

class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoggedIn: false,
			isOpen: false,
			loggedInLinks: [],
			crn: '',
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null,
			isLoading: true
		};
	}

	toggleDropdown = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	componentDidMount() {
		if (window.loginStatusReady) {

			const isLoggedIn = (window !== null && window.loginStatus !== null && window.loginStatus.isLoggedIn !== null) ? window.loginStatus.isLoggedIn : false;
			const loggedInLinks = (window !== null && window.loginStatus !== null && window.loginStatus.loggedInLinks !== null) ? window.loginStatus.loggedInLinks : [];
			const crn = (window.loginStatus && window.loginStatus.crn != null) ? window.loginStatus.crn : '';

			this.setState({
				isLoggedIn: isLoggedIn,
				loggedInLinks: loggedInLinks,
				crn: crn,
				isLoading: false
			});
			return;
		}

		const logonModule = require('Logon/Logon');

		const hasCookie = document.cookie.split('; ').some(cookie => cookie.startsWith('.AspNet.Cookies'));

		if (!hasCookie) {
			this.setState({ isLoading: false });

			window.defaultMParticleEventObject.login_status = "guest";
			window.dataLayer.push(window.defaultMParticleEventObject);

			window.loginStatusReady = true;

			window.loginStatus = {
				isLoggedIn: false,
				loggedInLinks: [],
				crn: '',
				numberForLife: null,
				tags: []
			};

			const event = new CustomEvent('loginInitialized', {
				detail: window.loginStatus
			});
			
			window.dispatchEvent(event);

			return;
		}

		logonModule.getLoginStatus()
		.then(logon => {
			this.setState({
				isLoggedIn: logon.isLoggedIn,
				loggedInLinks: logon.loggedInLinks,
				crn: logon.crn,
				numberForLife: logon.numberForLife,
				tags: logon.tags,
				isLoading: false
			});
	
			window.defaultMParticleEventObject.crn = logon.crn;
			window.defaultMParticleEventObject.customer_id = logon.numberForLife;
			window.defaultMParticleEventObject.topics_followed = logon.tags;
			window.defaultMParticleEventObject.login_status = logon.isLoggedIn ? "logged_in" : "guest";
		
			window.dataLayer.push(window.defaultMParticleEventObject);
		
			window.loginStatus = {
				isLoggedIn: logon.isLoggedIn,
				loggedInLinks: logon.loggedInLinks,
				crn: logon.crn,
				numberForLife: logon.numberForLife,
				tags: logon.tags
			};

			window.loginStatusReady = true;

			const event = new CustomEvent('loginInitialized', {
				detail: window.loginStatus
			});

			window.dispatchEvent(event);
		
			let emitter = require('sneakpeek').emitter;
		
			emitter.on('hide', () => {
				this.setState({ isOpen: false });
			});
		})
		.catch(error => {
			console.error('Error initializing Logon module:', error);
			this.setState({ isLoading: false });
		});
	}

	handleEsc = (e) => {
		if (e.key === 'Escape') {
			this.toggleDropdown();
			this.trigger.focus();
		}
	};

	handleLogOut = () => {
		window.loginStatusReady = false;
		window.loginStatus = null;
		const shouldTrackWithMParticle = this.state.defaultMParticleEventObject !== null;

		if (shouldTrackWithMParticle) {

			const eventData = {
				event: 'logout',
				login_status: 'guest'
			};

			const eventDataMerged = { ...this.state.defaultMParticleEventObject, ...eventData };
			window.dataLayer.push(eventDataMerged);

		}
	};

	render() {
		let loginUrl = `/myspurs/sign-in-register?returnUrl=${window.location.href}`;

		if (this.state.isLoading) {
			return <div className="Login"><span className='loading-login'>Logging in...</span></div>;
		}

		return !this.state.isLoggedIn ? (
			
			<span className="Login">
				<a href={loginUrl}>Sign in / Register</a>
			</span>
		) : (
			<div className="Login">
				<button ref={trigger => (this.trigger = trigger)} onClick={this.toggleDropdown} type="button" onKeyDown={this.handleEsc} aria-haspopup aria-expanded={this.state.isOpen}>My Account<img src={chevronIcon} alt="" /></button>

				{this.state.isOpen && (
					<div className="Login__dropdown" onKeyDown={this.handleEsc}>
					{this.state.loggedInLinks.map((link, index) => (
						<div key={link.caption + index} className="Login__item">
							<a 
								href={link.url} 
								target={link.newWindow ? '_blank' : '_self'} 
								rel={link.newWindow ? "noopener noreferrer" : undefined} 
								onClick={link.url.indexOf('log-out') !== -1 ? this.handleLogOut : undefined}
							>
								{link.caption}
							</a>
						</div>
					))}

					{this.state.crn !== '' && (
					<div className="Login__item__crn">
						<small>Your CRN: {this.state.crn}</small>
					</div>
					)}
				</div>
				)}
			</div>
		);
	}
}

module.exports = Login;



// WEBPACK FOOTER //
// ./src/components/LoginModule/LoginModule.js